import { cn } from '@mdxui/primitives/lib/utils'

export interface BlogAuthorProps {
  /** Author name */
  name: string
  /** Author role/position */
  role?: string
  /** Author avatar image URL */
  image?: string
  /** Additional className */
  className?: string
}

export function BlogAuthor({ name, role, image, className }: BlogAuthorProps) {
  return (
    <div className={cn('flex items-center gap-3 mb-6 pb-6 border-b border-border/50', className)}>
      {image && (
        <img
          src={image}
          alt={`${name}${role ? ` - ${role}` : ''}`}
          width={40}
          height={40}
          className="rounded-full object-cover"
        />
      )}
      <div>
        <p className="text-sm font-semibold text-card-foreground">{name}</p>
        {role && <p className="text-xs text-muted-foreground">{role}</p>}
      </div>
    </div>
  )
}
